import { ElevationLevelValues } from '../../style/tokens'
import { Colors } from '../../style/colors'
import { Fonts } from '../../style/fonts'

export const actionsTableCellStyle = {
  width: '0px',
}

export const filterActionStyle = {
  margin: '12px 0px',
  display: 'flex',
}

export const noResultsTableCellStyle = {
  ...Fonts.colors.SlateGrey,
  fontStyle: 'italic',
}

export const tableStyle = {
  width: '100%',
  borderCollapse: 'collapse',
  tableLayout: 'fixed' as const,
}

export const thStyle = {
  borderTop: `1px solid ${Colors.Platinum}`,
  borderBottom: `1px solid ${Colors.Platinum}`,
  padding: '0.25rem',
  textAlign: 'left' as const,
  fontWeight: 300,
  color: Colors.SlateGrey,
  backgroundColor: Colors.White,
  zIndex: ElevationLevelValues.middle,
}

export const thInfoStyle = {
  ...Fonts.P3,
  color: Colors.SlateGrey,
  fontStyle: 'italic',
  fontWeight: 500,
  marginLeft: '0.5rem',
}

export const tdStyle = {
  borderTop: `1px solid ${Colors.Platinum}`,
  borderBottom: `1px solid ${Colors.Platinum}`,
  borderLeft: 'none',
  borderRight: 'none',
  padding: '0.25rem 0.5rem',
  height: '38px',
  cursor: 'pointer',
}

export const noResultsTdStyle = {
  ...Fonts.colors.SlateGrey,
  fontStyle: 'italic',
  cursor: 'default',
  borderBottom: 'none',
}

export const checkboxThStyle = {
  width: '20px',
  borderTop: 'none',
  borderBottom: `1px solid ${Colors.Platinum}`,
}

export const checkboxTdStyle = {
  width: '20px',
  borderTop: `1px solid ${Colors.Platinum}`,
  borderBottom: `1px solid ${Colors.Platinum}`,
  borderLeft: 'none',
  borderRight: 'none',
}

export const checkboxWrapperStyle = {
  height: '100%',
  display: 'flex',
}
